<button [ngClass]="'state-' + state.toLowerCase()" (click)="handleClick()">
  {{ text }}
</button>
